import React from "react";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { cn } from "../../lib/utils";

export type StatusFilterTab = string | { value: string; label: string };

type StatusFilterTabsProps = {
  tabs: readonly StatusFilterTab[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  getCount?: (tab: StatusFilterTab) => number;
  className?: string;
  ariaLabel?: string;
};

function tabValue(tab: StatusFilterTab): string {
  return typeof tab === "string" ? tab : tab.value;
}

function tabLabel(tab: StatusFilterTab): string {
  return typeof tab === "string" ? tab : tab.label;
}

const StatusFilterTabs: React.FC<StatusFilterTabsProps> = ({
  tabs,
  value,
  onChange,
  disabled,
  getCount,
  className,
  ariaLabel,
}) => (
  <Tabs value={value} onValueChange={onChange} className={cn("tm-module-tabs min-w-0", className)}>
    <TabsList className="tm-module-tabs-list" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const tabKey = tabValue(tab);
        const count = getCount?.(tab);
        return (
          <TabsTrigger
            key={tabKey}
            value={tabKey}
            disabled={disabled}
            className="tm-module-tab-trigger"
          >
            {tabLabel(tab)}
            {count != null && (
              <span className={cn("tm-module-tab-count", value === tabKey && "is-active")}>
                {typeof count === "number" ? count.toLocaleString("en-US") : count}
              </span>
            )}
          </TabsTrigger>
        );
      })}
    </TabsList>
  </Tabs>
);

export default StatusFilterTabs;
